import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useSummaryModel } from "./summaryModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
        getSelectedDict
    } = useSummaryModel();

    const onSearch = (val = {}) => {
        loadData({ pageNum: 1 }, { ...searchParam, ...val })
    }

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "客户类型",
            fieldName: "categoryCode",
            size: "small",
            disabled: false,
            options: getSelectedDict(DictCodeEnmu.CUSTOMER_TYPE)
        }
    ]

    return (
        <YhPageHeader
            title="客户发票"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            triggerSearch
            onChange={updateSearchParam}
            handleSearch={onSearch}
            handleReset={resetSearchParam}
        />
    );
}